module.exports = __webpack_public_path__ + "img/overhaul_dark.fc7ce07e.svg";